import { render, staticRenderFns } from "./RegularPriceRow.vue?vue&type=template&id=466fdc56&scoped=true&"
import script from "./RegularPriceRow.vue?vue&type=script&lang=ts&"
export * from "./RegularPriceRow.vue?vue&type=script&lang=ts&"
import style0 from "./RegularPriceRow.vue?vue&type=style&index=0&id=466fdc56&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466fdc56",
  null
  
)

export default component.exports